<dx-scroll-view height="100%" [useNative]="false" [showScrollbar]="'always'">
  <dx-form
    [(formData)]="associationFormData"
    labelMode="floating"
    [validationGroup]="validationGroup"
    [colCount]="12"
  >
    <dxi-item [colSpan]="6">
      <div *dxTemplate>
        <ag-shr-relationship-type-select-box
          [(value)]="associationFormData[AssociationKeys.associationType]"
          (selectedItemChange)="handleRelationshipTypeSelectionChanged($event)"
        ></ag-shr-relationship-type-select-box>
      </div>
    </dxi-item>

    <dxi-item
      [dataField]="AssociationKeys.isEmergencyContact"
      [label]="{ text: 'Is Emergency Contact?' }"
      [alignItemLabels]="'left'"
      [colSpan]="6"
      editorType="dxSwitch"
      [cssClass]="'associations__switch-control'"
      [editorOptions]="{ switchedOffText: 'false', switchedOnText: 'true' }"
    ></dxi-item>

    <dxi-item [dataField]="AssociationKeys.firstName" [label]="{ text: 'First Name' }" [colSpan]="6"></dxi-item>

    <dxi-item [dataField]="AssociationKeys.lastName" [label]="{ text: 'Last Name' }" [colSpan]="6"></dxi-item>

    <dxi-item
      [dataField]="AssociationKeys.emailAddress"
      [label]="{ text: 'Email Address' }"
      [colSpan]="6"
    ></dxi-item>

    <dxi-item
      [dataField]="AssociationKeys.contactNumber"
      [label]="{ text: 'Phone Number' }"
      [colSpan]="6"
      [editorOptions]="{ mask: phoneMask }"
    >
      <dxi-validation-rule
        type="stringLength"
        [min]="totalPhoneDigits"
        [max]="totalPhoneDigits"
        [ignoreEmptyValue]="true"
        [trim]="true"
        [message]="Messages.INVALID_PHONE_DIGITS_TEXT"
      >
      </dxi-validation-rule>
    </dxi-item>

    <dxi-item
      [dataField]="AssociationKeys.dob"
      [colSpan]="6"
      editorType="dxDateBox"
      [label]="{ text: 'Date Of Birth' }"
      [editorOptions]="dateEditorOptions"
    >
    </dxi-item>

    <dxi-item [dataField]="AssociationKeys.gender" [colSpan]="6">
      <dxo-label [text]="'Gender'"></dxo-label>

      <div *dxTemplate>
        <ag-shr-gender-select-box
          [(value)]="associationFormData.gender"
          (selectedItemChange)="handleGenderSelect($event)"
        ></ag-shr-gender-select-box>
      </div>
    </dxi-item>
  </dx-form>
</dx-scroll-view>
